import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractFrontJacket from "../FrontJacket";

class FrontJacket extends AbstractFrontJacket {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-front-jackets-ipr';
  }
}

export default FrontJacket;
